export const WebSocketConfig = {
    url: 'ws://{domain}:8080/ws',
    urlTls: 'wss://{domain}:443/ws',
};
